import { ReactNode } from 'react';

import { BrandTile } from '@/components/BrandTile';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack, Typography } from '@mui/joy';

type PanelHeaderProps = {
  /** The agent select once the chat is shown, the app's name before that. */
  subtitle: ReactNode;
  /** The «⋯» menu. */
  actions?: ReactNode;
  /** Absent outside a frame: there is no launcher to close the panel. */
  onClose?: () => void;
};

/** «Gasbi AI» on top of the panel, with the agent under the name, the menu and «×». */
export const PanelHeader = ({
  subtitle,
  actions,
  onClose,
}: PanelHeaderProps) => (
  <Stack
    direction='row'
    alignItems='center'
    gap={1.5}
    sx={{
      px: 2,
      py: 1.25,
      borderBottom: '1px solid',
      borderColor: 'divider',
      flexShrink: 0,
    }}
  >
    <BrandTile />
    <Stack sx={{ flex: 1, minWidth: 0 }}>
      <Typography level='title-md'>Gasbi AI</Typography>
      {typeof subtitle === 'string' ? (
        <Typography level='body-xs' textColor='neutral.500' noWrap>
          {subtitle}
        </Typography>
      ) : (
        subtitle
      )}
    </Stack>
    {actions}
    {onClose && (
      <IconButton
        size='sm'
        variant='plain'
        color='neutral'
        aria-label='Закрити чат'
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    )}
  </Stack>
);
